export const ANALYTICS_GLOSSARY: Record<string, { en: string; ar: string }> = {
  mmecScore: {
    en: 'MMEC Score (0–100) blends RTL, contract whale flow, gamma context, and index consensus into one bias gauge.',
    ar: 'درجة MMEC (0–100) تجمع RTL وتدفق الحيتان وسياق الجاما وإجماع المؤشر في مؤشر واحد.',
  },
  whalePremium: {
    en: 'Total premium on large prints for this exact strike/expiry — buy vs sell shows positioning.',
    ar: 'إجمالي العلاوة على الصفقات الكبيرة لهذا العقد — الشراء مقابل البيع يوضح التمركز.',
  },
  rtl: {
    en: 'RTL Legacy tracks bid/ask accumulation on the underlying — direction hints institutional bias.',
    ar: 'RTL Legacy يتتبع تراكم العرض/الطلب على الأصل — الاتجاه يشير إلى انحياز المؤسسات.',
  },
  gammaFlip: {
    en: 'Price where dealer gamma flips sign — above often more bullish pinning, below more volatile.',
    ar: 'السعر الذي تنعكس عنده جاما الموزع — فوقه غالباً تثبيت صعودي، تحته تقلب أعلى.',
  },
  flowBias: {
    en: 'Share of whale premium tagged as buy vs sell on this contract today.',
    ar: 'نسبة علاوة الحيتان المصنفة شراء مقابل بيع على هذا العقد اليوم.',
  },
};

export function glossary(key: keyof typeof ANALYTICS_GLOSSARY, lang: string): string {
  const entry = ANALYTICS_GLOSSARY[key];
  return lang === 'ar' ? entry.ar : entry.en;
}
